var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  viewBox: "0 0 21 22",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 5.60645H19.459",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.30469 5.60645H17.1572V19.459C17.1572 19.8732 16.9915 20.2543 16.7098 20.5526C16.4281 20.8509 16.0305 21 15.6162 21H4.8457C4.43145 21 4.05034 20.8343 3.75208 20.5526C3.47039 20.2709 3.30469 19.8732 3.30469 19.459V5.60645Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38477 5.60646V4.84424C6.38477 3.8169 6.78245 2.83927 7.51153 2.12676C8.24061 1.39768 9.21824 1 10.229 1C11.2398 1 12.234 1.39768 12.9465 2.12676C13.6756 2.85584 14.0733 3.83347 14.0733 4.84424V5.60646",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.92578 10.2129V16.3769",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5332 10.2129V16.3769",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTrash;